import {when} from 'mobx';

import {Mixin, mix} from 'mixwith';

import SimgateAuth from './component.js';

// this mock component mixin is necessary when a superclass is "injected", ie when @editable is used
// it merges statics onto the wrappedComponent so they are still accessible
const MockComponentMixin = Mixin( (superclass) => class extends superclass {
  constructor(){
    super(...arguments);
    if(superclass.wrappedComponent){
      Object.keys(this.constructor)
        .forEach( k => {superclass.wrappedComponent[k] = this.constructor[k];} );
    }
  }
})

export default class SimgateAuthMock extends mix(SimgateAuth).with(MockComponentMixin){
  static setUpMock = function(context){
    const {
      dataModel: {
        domainStore
      },
      contentModel: {
        apiUrl,
        applicationId
      }, 
      currentView: {
        route
      }
    } = context.props;

    domainStore.mockRoleId = route.role.roleId

  }
}


// WEBPACK FOOTER //
// ./app_modules/deloitte-auth-strategy/component.mock.js